import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const GenReviews = () => {
    const [genReviews, setGenReviews] = useState([]);
    const [genReviewsFiltered, setGenReviewsFiltered] = useState([]);

    useEffect(() => {
        fetch(process.env.REACT_APP_BACKEND_URL + 'get_all_generated_reviews', {
            method: "POST",
            headers: {
                "Content-Type": "text/plain",
            },
            body: JSON.stringify({ token: localStorage.getItem("token"), username: localStorage.getItem("user") }),
        })
            .then(response => response.json())
            .then(data => {
                setGenReviews(data);
                setGenReviewsFiltered(data);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }, []);

    function filter() {
        let aux_gen = genReviews;

        let currentStatus = document.getElementById("selectStatus").value;

        if (currentStatus === 'Reviewed') {
            aux_gen = aux_gen.filter(genReview => genReview.reviewed === true);
        }
        if (currentStatus === 'Not_Reviewed') {
            aux_gen = aux_gen.filter(genReview => genReview.reviewed === false);
        }

        setGenReviewsFiltered(aux_gen);
    }


    return (
        <>
            <div className="m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h1 className="text-base font-semibold leading-7 text-gray-900">Generated Reviews</h1>
                </div>
            </div>

            <div className="m-10 border-b border-gray-900/10">
                <div className="justify-center">
                    <h2 className="text-base font-medium leading-7 text-gray-900">Filters</h2>
                </div>

                <div className="grid grid-cols-6">
                    <div class="flex flex-wrap -mx-3 mb-2 col-span-2">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="selectStatus">
                            Status:
                        </label>
                        <div class="relative">
                            <select id="selectStatus" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" onChange={(e) => filter()}>
                                <option value="">All</option>
                                <option value="Reviewed">Reviewed</option>
                                <option value="Not_Reviewed">Not Reviewed</option>
                            </select>
                        </div>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
            </div>

            <div className="m-10">
                {genReviewsFiltered.length > 0 && (
                    (() => {
                        const secureCount = genReviewsFiltered.filter(c => c.reviewed === true).length;
                        const total = genReviewsFiltered.length;
                        const percentage = (secureCount / total) * 100;

                        // Calculate green color: hue=120 (green) and adjust lightness
                        const lightness = 80 - (percentage * 0.5); // from 80% (light) to 30% (dark)
                        const barColor = `hsl(120, 60%, ${lightness}%)`;

                        return (
                            <div className="flex items-center space-x-4">
                                <div className="w-full bg-gray-200 rounded-full h-6 relative">
                                    <div
                                        className="h-6 rounded-full transition-all duration-500"
                                        style={{
                                            width: `${percentage}%`,
                                            backgroundColor: barColor,
                                        }}
                                    ></div>
                                </div>
                                <div className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                                    {secureCount} / {total}
                                </div>
                            </div>
                        );
                    })()
                )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                {genReviewsFiltered.map(genReview => (
                    <div key={genReview.sha} 
                    className={`col-span-1 shadow-md hover:shadow-lg m-5 ${genReview.reviewed === true ? 'bg-gray-400' : ''}`}>
                        <Link to={`/genReview/${genReview.sha}`}>
                            <p><b>Sha:</b> {genReview.sha}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </>
    );
};

export default GenReviews;